import React from 'react';
import './canada.css'; // Import the CSS for styling

const Canada = () => {
  return (
    <div className="canada-page">
      <header className="canada-header">
        <h1>Study in Canada</h1> {/* Header for the page */}
      </header>
      <main className="canada-content">
        <section className="canada-section">
          <h2>Top-Quality Education</h2>
          <p>
            Canada is home to some of the best universities in the world, 
            including the University of Toronto, McGill University, and the 
            University of British Columbia. Canadian institutions are renowned 
            for their academic excellence and strong emphasis on research and innovation.
          </p>
        </section>
        <section className="canada-section">
          <h2>Safe and Inclusive Society</h2>
          <p>
            Canada is one of the safest countries for international students, 
            with a reputation for being welcoming and inclusive. It offers a high 
            quality of life, making it an attractive destination for students seeking 
            a secure and supportive environment.
          </p>
        </section>
        <section className="canada-section">
          <h2>Post-Graduation Work Permits</h2>
          <p>
            Canada provides ample opportunities for students to work after graduation. 
            The Post-Graduation Work Permit (PGWP) allows students to stay in Canada and 
            gain valuable work experience, which can be a pathway to permanent residency.
          </p>
        </section>
      </main>
      <footer className="canada-footer">
        <p>Explore the opportunities that await you in Canada!</p>
      </footer>
    </div>
  );
};

export default Canada;
